module.exports = __webpack_public_path__ + "static/media/background.745479ab.png";